import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Doctor(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 18 24">
      <path d="M15.5 13a2.5 2.5 0 00-.5 4.95V19a4 4 0 11-8 0v-5.025A6.504 6.504 0 0013 7.5v-6c0-.828-.672-1.5-1.5-1.5h-2a.5.5 0 000 1h2a.5.5 0 01.5.5v6a5.5 5.5 0 01-11 0v-6a.5.5 0 01.5-.5h2a.5.5 0 000-1h-2C.672 0 0 .672 0 1.5v6a6.504 6.504 0 006 6.475V19a5 5 0 0010 0v-1.05a2.5 2.5 0 00-.5-4.95zm0 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"></path>
    </IconSvg>
  );
}
